import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup, TabContent, TabPane } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import PropTypes from "prop-types";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";
import { api } from "../../../config";
import ModalImage from "react-modal-image";
import CurrencyInput from "react-currency-input-field";
import { QRCodeSVG } from "qrcode.react";
import moment from "moment";
import "moment-timezone";
import "moment/locale/id";

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";
import { useSelector, useDispatch } from "react-redux";

import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { getBank } from "../../../store/bank/action";
import { getBankBranch } from "../../../store/bankBranch/action";
import { resetPaymentMethodState, getPaymentMethod } from "../../../store/paymentMethod/action";
import { resetBudgetState, getBudget } from "../../../store/budget/action";
import { resetSalesTypeState, getSalesType } from "../../../store/salesType/action";
import { resetSalesState, getSales as onGetSales, addNewSales as onAddNewSales, updateSales as onUpdateSales, deleteSales as onDeleteSales, getSalesLoading, resetSalesCreateState } from "../../../store/sales/action";

import logo from "../../../assets/images/logo-sm.png";
import logoHas from "../../../assets/images/LOGO HAS.png";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ModalInputFile from "../../../Components/ModalInputFile";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { ButtonPrint, PrintDoc } from "./PrintDoc";
import { ButtonPrintInvoice, PrintInvoice } from "./PrintInvoice";
import { getAccTrans } from "../../../store/accTrans/action";

const proyekPrintOptions = [{ label: "Pesona Kahuripan 11", value: "Pesona Kahuripan 11" }];
const bankPrintOptions = [
  {
    label: "Bank BTN Cabang Bogor",
    value: "Bank BTN Cabang Bogor",
    data: {
      name: "PT. HIKMAH ALAM SENTOSA",
      noAccount: "0001.5013.0001.4164",
    },
  },
];

const initialDataPrintSelected = {
  proyek: null,
  bank: null,
  application: null,
};

const Sales = (props) => {
  const printRef = useRef(null);
  const printRefInvoice = useRef(null);
  const [isButtonPrint, setIsButtonPrint] = useState(false);
  const [dataPrintSelected, setDataPrintSelected] = useState(initialDataPrintSelected);
  const [dataPrintList, setDataPrintList] = useState([]);
  const [dataPrintReceivableList, setDataPrintReceivableList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalPrint, setModalPrint] = useState(false);
  const [modalAccPayment, setModalAccPayment] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalApprove, setModalApprove] = useState(false);
  const [indexPage, setIndexPage] = useState(0);
  const [modalReceipt, setModalReceipt] = useState(false);
  const [activeProgress, setActiveProgress] = useState("all");

  const dispatch = useDispatch();

  const { accTranss, loadingAccTranss, clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, saless, salesAdded, isSalesCreated, isSalesSuccess, loading, error, paymentMethods, paymentMethodLoading, companies, companyLoading, banks, bankLoading, bankBranches, bankBranchLoading, branches, branchLoading, salesTypes, salesTypeLoading, budgets, budgetLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    saless: state.Sales.saless,
    loading: state.Sales.loading,
    isSalesCreated: state.Sales.isSalesCreated,
    isSalesSuccess: state.Sales.isSalesSuccess,
    salesAdded: state.Sales.salesAdded,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    paymentMethods: state.PaymentMethod.paymentMethods,
    paymentMethodLoading: state.PaymentMethod.loading,
    paymentTerms: state.PaymentTerm.paymentTerms,
    paymentTermLoading: state.PaymentTerm.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    transactionTaxs: state.TransactionTax.transactionTaxs,
    transactionTaxLoading: state.TransactionTax.loading,
    salesTypes: state.SalesType.salesTypes,
    salesTypeLoading: state.SalesType.loading,
    error: state.Sales.error,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    banks: state.Bank.banks,
    bankLoading: state.Bank.loading,
    bankBranches: state.BankBranch.bankBranches,
    bankBranchLoading: state.BankBranch.loading,
    budgets: state.Budget.budgets,
    budgetLoading: state.Budget.loading,
    accTranss: state.AccTrans.accTranss,
    loadingAccTranss: state.AccTrans.loading,
  }));

  const [salesList, setSalesList] = useState([]);
  const [salesOriginalList, setSalesOriginalList] = useState([]);
  const [salesDoc, setSalesDoc] = useState([]);
  const [sales, setSales] = useState(null);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [branchList, setBranchList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [searchType, setSearchType] = useState("");
  const [salesTypeList, setSalesTypeList] = useState([]);
  const [bankBranchList, setBankBranchList] = useState([]);

  const [isEdit, setIsEdit] = useState(false);
  const [isPayment, setIsPayment] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [itemName, setItemName] = useState("Print");
  const [budgetList, setBudgetList] = useState([]);

  const [modalMedia, setModalMedia] = useState(false);
  const [modalMediaCustomer, setModalMediaCustomer] = useState(false);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [salesImg, setSalesImg] = useState([]);
  const [salesImgCustomer, setSalesImgCustomer] = useState([]);

  const [receiptAmount, setReceiptAmount] = useState(0);
  const [receiptDate, setReceiptDate] = useState(0);
  const [receiptCode, setReceiptCode] = useState(0);
  const [branchCode, setBranchCode] = useState(0);
  const [receiptName, setReceiptName] = useState(0);
  const [receiptNote, setReceiptNote] = useState(0);

  const [actionType, setActionType] = useState(null);

  const [transactionList, setTransactionList] = useState([]);

  const scrollRef = useRef(null);

  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [startY, setStartY] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [scrollTop, setScrollTop] = useState(0);

  const handleMouseDown = (e) => {
    setIsDown(true);

    const rect = scrollRef.current.getBoundingClientRect();

    setStartX(e.clientX - rect.left);
    setStartY(e.clientY - rect.top);

    setScrollLeft(scrollRef.current.scrollLeft);
    setScrollTop(scrollRef.current.scrollTop);
  };

  const handleMouseLeave = () => {
    setIsDown(false);
  };

  const handleMouseUp = () => {
    setIsDown(false);
  };

  const handleMouseMove = (e) => {
    if (!isDown) return;

    e.preventDefault();

    const rect = scrollRef.current.getBoundingClientRect();

    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const walkX = (x - startX) * 1.5; // speed horizontal
    const walkY = (y - startY) * 1.5; // speed vertical

    scrollRef.current.scrollLeft = scrollLeft - walkX;
    scrollRef.current.scrollTop = scrollTop - walkY;
  };

  const toggleType = (type) => {
    let filteredSales = saless;
    if (type !== "all") {
      filteredSales = saless.filter((sales) => sales.typeId === type);
    }
    setSalesList(filteredSales);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    setSalesList(saless);
    setSalesOriginalList(saless);
  }, [saless]);

  useEffect(() => {
    if (branchSelected && companySelected) {
      dispatch(getBank());
      dispatch(getBankBranch());
      handleGetSalesType(companySelected?.value);
      handleGetPaymentMethod(companySelected?.value, branchSelected?.value);
      handleGetSales(companySelected?.value, branchSelected?.value, false);
      handleGetBudget(companySelected?.value, branchSelected?.value);
    }
  }, [branchSelected, companySelected]);

  const handleGetBudget = (companyId, branchId) => {
    dispatch(resetBudgetState());
    dispatch(getBudget({ companyId: companyId, status: 2, branchId: branchId, simple: true }));
  };

  const handleGetSales = (companyId, branchId, isSimple) => {
    dispatch(resetSalesState());
    dispatch(onGetSales({ companyId: companyId, branchId: branchId, tag: "Finance", simple: "true", date: "all" })); //, simple: isSimple
  };

  const handleGetPaymentMethod = (id, branchId) => {
    dispatch(resetPaymentMethodState());
    dispatch(getPaymentMethod({ companyId: id, branchId: branchId, status: 2, type: "all" }));
  };

  const handleGetSalesType = (id) => {
    dispatch(resetSalesTypeState());
    dispatch(getSalesType({ companyId: id, status: 2 }));
  };

  useEffect(() => {
    if (!isEmpty(saless)) {
      setSalesList(saless.map((el) => ({ ...el, isChecked: false })));
      setInfo(saless[saless.length - 1]);
    }
  }, [saless]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "sales_type",
        label: "Jenis Penjualan",
        isSelected: true,
        data: [],
      },
      {
        id: "sales_customer",
        label: "Debitur",
        isSelected: true,
        data: [],
      },
      {
        id: "phone",
        label: "No Telp Debitur",
        isSelected: true,
        data: [],
      },
      {
        id: "sales_agent",
        label: "Marketing",
        isSelected: true,
        data: [],
      },
      {
        id: "sales_detail",
        label: "Blok",
        isSelected: true,
        data: [],
      },
      {
        id: "hoek",
        label: "Hoek",
        isSelected: true,
        data: [],
      },
      {
        id: "process_amount",
        label: "Biaya Proses",
        isSelected: true,
        data: [],
      },
      {
        id: "book_amount",
        label: "Biaya Booking",
        isSelected: true,
        data: [],
      },
      {
        id: "disc_amount",
        label: "Potongan Diskon",
        isSelected: true,
        data: [],
      },
      {
        id: "payment",
        label: "Pembayaran Lainnya",
        isSelected: true,
        data: [],
      },
      {
        id: "receivable_payment",
        label: "Pencairan Piutang",
        isSelected: true,
        data: [],
      },
      {
        id: "total_amount",
        label: "Harus Bayar",
        isSelected: true,
        data: [],
      },
      {
        id: "receivable",
        label: "Piutang KPR",
        isSelected: true,
        data: [],
      },
      {
        id: "receivable_desc",
        label: "Status Piutang KPR",
        isSelected: true,
        data: [],
      },
      {
        id: "sbum_amount",
        label: "Retensi SBUM",
        isSelected: true,
        data: [],
      },
      {
        id: "sbum_desc",
        label: "Status Retensi SBUM",
        isSelected: true,
        data: [],
      },
      {
        id: "cert_amount",
        label: "Retensi Sertifikat",
        isSelected: true,
        data: [],
      },
      {
        id: "cert_desc",
        label: "Status Retensi Sertifikat",
        isSelected: true,
        data: [],
      },
      {
        id: "imb_amount",
        label: "Retensi PBG",
        isSelected: true,
        data: [],
      },
      {
        id: "imb_desc",
        label: "Status Retensi PBG",
        isSelected: true,
        data: [],
      },
      {
        id: "electricity_amount",
        label: "Retensi Listrik",
        isSelected: true,
        data: [],
      },
      {
        id: "electricity_desc",
        label: "Status Retensi Listrik",
        isSelected: true,
        data: [],
      },
      {
        id: "jkk_amount",
        label: "Retensi JKK",
        isSelected: true,
        data: [],
      },
      {
        id: "jkk_desc",
        label: "Status Retensi JKK",
        isSelected: true,
        data: [],
      },
      {
        id: "bestek_amount",
        label: "Retensi BESTEK",
        isSelected: true,
        data: [],
      },
      {
        id: "bestek_desc",
        label: "Status Retensi BESTEK",
        isSelected: true,
        data: [],
      },
      {
        id: "ppjb_amount",
        label: "Retensi PPJB",
        isSelected: true,
        data: [],
      },
      {
        id: "ppjb_desc",
        label: "Status Retensi PPJB",
        isSelected: true,
        data: [],
      },
      {
        id: "thp3_amount",
        label: "Retensi THP 3",
        isSelected: true,
        data: [],
      },
      {
        id: "thp3_desc",
        label: "Status Retensi THP 3",
        isSelected: true,
        data: [],
      },
      {
        id: "thp4_amount",
        label: "Retensi THP 4",
        isSelected: true,
        data: [],
      },
      {
        id: "thp4_desc",
        label: "Status Retensi THP 4",
        isSelected: true,
        data: [],
      },
      {
        id: "bn_amount",
        label: "Biaya BN Notaris",
        isSelected: true,
        data: [],
      },
      {
        id: "pph_amount",
        label: "Biaya PPH",
        isSelected: true,
        data: [],
      },
      {
        id: "bphtb_amount",
        label: "Biaya BPHTB",
        isSelected: true,
        data: [],
      },
      {
        id: "materai_amount",
        label: "Biaya Materai",
        isSelected: true,
        data: [],
      },
      {
        id: "kyg_amount",
        label: "Biaya KYG",
        isSelected: true,
        data: [],
      },
      {
        id: "bookat",
        label: "Tanggal Booking",
        isSelected: false,
        data: [],
      },
      {
        id: "officeat",
        label: "Tanggal Kantor",
        isSelected: false,
        data: [],
      },
      {
        id: "bankat",
        label: "Tanggal Bank",
        isSelected: false,
        data: [],
      },
      {
        id: "sp3at",
        label: "Tanggal SP3K",
        isSelected: false,
        data: [],
      },
      {
        id: "completedat",
        label: "Tanggal Akad",
        isSelected: false,
        data: [],
      },
      {
        id: "sls_bb",
        label: "Bank Pengajuan",
        isSelected: false,
        data: [],
      },
      {
        id: "bank_no",
        label: "No Rekening",
        isSelected: false,
        data: [],
      },
      {
        id: "credit_amount",
        label: "ACC KPR",
        isSelected: false,
        data: [],
      },
      {
        id: "handling_amount",
        label: "Administrasi",
        isSelected: false,
        data: [],
      },
      {
        id: "payment_cust_no",
        label: "No Pembayaran Konsumen",
        isSelected: false,
        data: [],
      },
      {
        id: "sales_promo",
        label: "Diskon & Promo",
        isSelected: false,
        data: [],
      },
      {
        id: "sales_deal_status",
        label: "Status Penjualan",
        isSelected: false,
        data: [],
      },
      {
        id: "sales_bank_status",
        label: "Status Bank",
        isSelected: false,
        data: [],
      },
      {
        id: "sales_client",
        label: "Grup Usaha",
        isSelected: false,
        data: [],
      },
      {
        id: "sales_company",
        label: "Perusahaan",
        isSelected: false,
        data: [],
      },
      {
        id: "sales_branch",
        label: "Cabang",
        isSelected: false,
        data: [],
      },
      {
        id: "job_business_name",
        label: "Nama Perusahaan / PT",
        isSelected: false,
        data: [],
      },
    ];

    if (salesList.length > 0) {
      salesList.forEach((sales) => {
        if (sales.isChecked) {
          let first = true;
          let doc = dataDoc.find((d) => d.id === "transaction_no");
          if (doc) doc.data.push(sales.transaction_no);

          doc = dataDoc.find((d) => d.id === "sales_type");
          if (doc) doc.data.push(sales?.sales_type?.name);

          doc = dataDoc.find((d) => d.id === "sales_customer");
          if (doc) doc.data.push(sales?.sales_customer?.name);

          doc = dataDoc.find((d) => d.id === "phone");
          if (doc) doc.data.push(sales?.sls_appl?.phone);

          doc = dataDoc.find((d) => d.id === "sales_agent");
          if (doc) doc.data.push(sales?.sales_agent?.name);

          doc = dataDoc.find((d) => d.id === "sales_detail");
          if (doc) doc.data.push(sales.sales_detail && sales.sales_detail.length > 0 ? `${sales?.sales_detail[0]?.sales_detail_product?.product_block?.name} - ${sales?.sales_detail[0]?.sales_detail_product?.name}` : ``);

          doc = dataDoc.find((d) => d.id === "hoek");
          if (doc) doc.data.push(sales.sales_detail && sales.sales_detail.length > 0 && sales?.sales_detail[0]?.land_excess ? sales?.sales_detail[0]?.land_excess : 0);

          doc = dataDoc.find((d) => d.id === "payment");
          if (doc) {
            let amount = 0;
            (sales?.sales_trans || [])
              .filter((f) => f.statusId === 1 || f.statusId === 2 || f.statusId === 3)
              .forEach((element) => {
                if (element.type === "CASH IN" && !element.accTransPaymentId) {
                  if (element.description.includes("DISKON")) amount -= element.amount ? parseFloat(element.amount) : 0;
                  else amount += element.amount ? parseFloat(element.amount) : 0;
                }
              });
            doc.data.push(parseFloat(amount));
          }
          doc = dataDoc.find((d) => d.id === "receivable_payment");
          if (doc) {
            let amount = 0;
            (sales?.sales_trans || [])
              .filter((f) => f.statusId === 1 || f.statusId === 2 || f.statusId === 3)
              .forEach((element) => {
                if (element.type === "CASH IN" && element.accTransPaymentId) {
                  if (element.description.includes("DISKON")) amount -= element.amount ? parseFloat(element.amount) : 0;
                  else amount += element.amount ? parseFloat(element.amount) : 0;
                }
              });
            doc.data.push(parseFloat(amount));
          }
          doc = dataDoc.find((d) => d.id === "total_amount");
          if (doc) {
            const sbum = parseFloat(0.01 * sales.sub_amount) + parseFloat(sales.sales_branch.sbum);
            const disc = parseFloat(sales.disc_amount || 0);
            const total = sales.typeId === 1 ? parseFloat(sales.total_amount || 0) - sbum + parseFloat(sales.book_amount || 0) - parseFloat(sales.credit_amount || 0) - disc : parseFloat(sales.total_amount || 0) + parseFloat(sales.book_amount || 0) - parseFloat(sales.credit_amount || 0) - disc;
            doc.data.push(sales.sales_detail.length ? parseFloat(total) : "");
          }

          doc = dataDoc.find((d) => d.id === "book_amount");
          if (doc) doc.data.push(parseFloat(sales.book_amount || 0));

          doc = dataDoc.find((d) => d.id === "disc_amount");
          if (doc) doc.data.push(parseFloat(sales.disc_amount || 0));

          doc = dataDoc.find((d) => d.id === "process_amount");
          if (doc) doc.data.push(sales.process_amount ? parseFloat(sales.process_amount || 0) : "");

          doc = dataDoc.find((d) => d.id === "sales_pm");
          if (doc) doc.data.push(sales?.sales_pm?.name);

          doc = dataDoc.find((d) => d.id === "bookat");
          if (doc) doc.data.push(sales.transactionat ? handleValidDate(sales.transactionat) : "");

          doc = dataDoc.find((d) => d.id === "officeat");
          if (doc) doc.data.push(sales.docat ? handleValidDate(sales.docat) : "");

          doc = dataDoc.find((d) => d.id === "bankat");
          if (doc) doc.data.push(sales.bankat ? handleValidDate(sales.bankat) : "");

          doc = dataDoc.find((d) => d.id === "sp3at");
          if (doc) doc.data.push(sales.sp3at ? handleValidDate(sales.sp3at) : "");

          doc = dataDoc.find((d) => d.id === "completedat");
          if (doc) doc.data.push(sales.completedat ? handleValidDate(sales.completedat) : "");

          doc = dataDoc.find((d) => d.id === "sls_bb");
          if (doc) doc.data.push(sales?.sls_bb?.name);

          doc = dataDoc.find((d) => d.id === "bank_no");
          if (doc) doc.data.push(sales?.sls_appl?.bank_no);

          doc = dataDoc.find((d) => d.id === "credit_amount");
          if (doc) doc.data.push(parseFloat(sales?.credit_amount || 0));

          doc = dataDoc.find((d) => d.id === "handling_amount");
          if (doc) doc.data.push(parseFloat(sales?.handling_amount || 0));

          doc = dataDoc.find((d) => d.id === "payment_cust_no");
          if (doc) doc.data.push(sales?.payment_cust_no);

          doc = dataDoc.find((d) => d.id === "sales_promo");
          if (doc) doc.data.push(sales?.sales_promo?.name);

          doc = dataDoc.find((d) => d.id === "sales_deal_status");
          if (doc) doc.data.push(sales.typeId !== 3 && sales.typeId !== 4 ? sales?.sales_deal_status?.name : "CASH");

          doc = dataDoc.find((d) => d.id === "sales_bank_status");
          if (doc) doc.data.push(sales?.sales_bank_status?.name);

          doc = dataDoc.find((d) => d.id === "description_bank");
          if (doc) doc.data.push(sales?.description_bank);

          doc = dataDoc.find((d) => d.id === "sales_client");
          if (doc) doc.data.push(sales?.sales_client?.name);

          doc = dataDoc.find((d) => d.id === "sales_company");
          if (doc) doc.data.push(sales?.sales_company?.name);

          doc = dataDoc.find((d) => d.id === "sales_branch");
          if (doc) doc.data.push(sales?.sales_branch?.name);

          doc = dataDoc.find((d) => d.id === "cert_amount");
          if (doc) doc.data.push(sales?.cert_amount);

          doc = dataDoc.find((d) => d.id === "cert_desc");
          if (doc) doc.data.push(sales?.cert_desc);

          doc = dataDoc.find((d) => d.id === "imb_amount");
          if (doc) doc.data.push(sales?.imb_amount);

          doc = dataDoc.find((d) => d.id === "imb_desc");
          if (doc) doc.data.push(sales?.imb_desc);

          doc = dataDoc.find((d) => d.id === "electricity_amount");
          if (doc) doc.data.push(sales?.electricity_amount);

          doc = dataDoc.find((d) => d.id === "electricity_desc");
          if (doc) doc.data.push(sales?.electricity_desc);

          doc = dataDoc.find((d) => d.id === "jkk_amount");
          if (doc) doc.data.push(sales?.jkk_amount);

          doc = dataDoc.find((d) => d.id === "jkk_desc");
          if (doc) doc.data.push(sales?.jkk_desc);

          doc = dataDoc.find((d) => d.id === "bestek_amount");
          if (doc) doc.data.push(sales?.bestek_amount);

          doc = dataDoc.find((d) => d.id === "bestek_desc");
          if (doc) doc.data.push(sales?.bestek_desc);

          doc = dataDoc.find((d) => d.id === "water_amount");
          if (doc) doc.data.push(sales?.water_amount);

          doc = dataDoc.find((d) => d.id === "water_desc");
          if (doc) doc.data.push(sales?.water_desc);

          doc = dataDoc.find((d) => d.id === "sbum_amount");
          if (doc) doc.data.push(sales?.sbum_amount);

          doc = dataDoc.find((d) => d.id === "sbum_desc");
          if (doc) doc.data.push(sales?.sbum_desc);

          doc = dataDoc.find((d) => d.id === "ppjb_amount");
          if (doc) doc.data.push(sales?.ppjb_amount);

          doc = dataDoc.find((d) => d.id === "ppjb_desc");
          if (doc) doc.data.push(sales?.ppjb_desc);

          doc = dataDoc.find((d) => d.id === "thp3_amount");
          if (doc) doc.data.push(sales?.thp3_amount);

          doc = dataDoc.find((d) => d.id === "thp3_desc");
          if (doc) doc.data.push(sales?.thp3_desc);

          doc = dataDoc.find((d) => d.id === "thp4_amount");
          if (doc) doc.data.push(sales?.thp4_amount);

          doc = dataDoc.find((d) => d.id === "thp4_desc");
          if (doc) doc.data.push(sales?.thp4_desc);

          doc = dataDoc.find((d) => d.id === "bn_amount");
          if (doc) doc.data.push(sales?.bn_amount);

          doc = dataDoc.find((d) => d.id === "pph_amount");
          if (doc) doc.data.push(sales?.pph_amount);

          doc = dataDoc.find((d) => d.id === "bphtb_amount");
          if (doc) doc.data.push(sales?.bphtb_amount);

          doc = dataDoc.find((d) => d.id === "materai_amount");
          if (doc) doc.data.push(sales?.materai_amount);

          doc = dataDoc.find((d) => d.id === "kyg_amount");
          if (doc) doc.data.push(sales?.kyg_amount);

          doc = dataDoc.find((d) => d.id === "receivable");
          if (doc) doc.data.push(sales?.receivable);

          doc = dataDoc.find((d) => d.id === "receivable_desc");
          if (doc) doc.data.push(sales?.receivable_desc);
        }
      });
    }
    setSalesDoc(dataDoc);
  }, [salesList]);

  useEffect(() => {
    if (!isEmpty(bankBranches)) {
      var data = [];
      var opt = [];
      bankBranches.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setBankBranchList(data);
    }
  }, [bankBranches]);

  useEffect(() => {
    if (!isEmpty(budgets)) {
      var data = [];
      var opt = [{ label: "", value: "" }];
      budgets.forEach((item, key) => {
        const name = item.type + " - " + item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setBudgetList(data);
    } else {
      setBudgetList([]);
    }
  }, [budgets]);

  useEffect(() => {
    if (!isEmpty(paymentMethods)) {
      var data = [];
      var opt = [];
      var obj_transaction = [];
      paymentMethods.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, sort_order: item?.sort_order + "-" };
        opt.push(obj);
        if (item.type === "Finance") {
          const s = accTranss ? (accTranss || []).filter((f) => f.statusId === 1 || f.statusId === 2 || f.statusId === 3).find((ff) => item.id === ff.paymentMethodId) : {};
          let amount = item.sales === "sls_amount" ? 185000000 : item.sales === "dp_amount" ? 1850000 : s?.amount ? parseFloat(s?.amount) : 0;
          let transactionat = s?.transactionat ?? moment().format("YYYY/MM/DD");


          obj_transaction.push({
            paymentMethodId: id,
            paymentMethodName: name,
            description: item.description,
            sales: item.sales,
            cash_amount: amount,
            cashat: transactionat,
            sort_order: item?.sort_order + "-",
            sort: item?.sort_order,
          });
        }

      });
      var option = { options: opt.sort((a, b) => a.sort_order.localeCompare(b.sort_order, undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setPaymentMethodList(data);
      setTransactionList(obj_transaction.sort((a, b) => a.sort_order.localeCompare(b.sort_order, undefined, { numeric: true, sensitivity: "base" })));
    } else {
      setTransactionList([]);
      setPaymentMethodList([]);
    }
  }, [paymentMethods, accTranss]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (isSalesCreated) {
      setSalesData(salesAdded);
      setIsEdit(true);
      let itemName = salesAdded.sales_detail.length > 0 ? " " + salesAdded.sales_detail[0]?.name : "";
      setItemName(itemName);
      setReceiptName(salesAdded.sales_customer.name);
      setBranchCode(salesAdded.sales_branch.branch_code);
      const dataInfoWithTrans = {
        ...info,
        sales_trans: salesAdded.sales_trans,
      };

      setInfo(dataInfoWithTrans);

      validation.setFieldValue("paymentMethodId", "");
      validation.setFieldValue("cash_amount", 0);
      validation.setFieldValue("statusId", salesAdded.statusId);
      validation.setFieldValue("statusDealId", salesAdded.statusDealId);
    }
  }, [isSalesCreated, salesAdded]);

  useEffect(() => {
    if (!isEmpty(salesTypes)) {
      var data = [];
      var opt = [];
      salesTypes.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setSalesTypeList(data);
    }
  }, [salesTypes]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, sbum: parseFloat(item.sbum) };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  const handleDeleteSales = () => {
    if (info) {
      dispatch(onDeleteSales(info));
      setDeleteModal(false);
    }
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setSales(null);
      setIsEdit(false);
      setIsPayment(false);
      setActionType(null);
      validation.resetForm();
    } else {
      setModal(true);
    }
  }, [modal]);

  const togglePrint = useCallback(() => {
    if (modalPrint) {
      setModalPrint(false);
      setDataPrintSelected(initialDataPrintSelected);
      setDataPrintList([]);
      setDataPrintReceivableList([]);
    } else {
      const optApplication = transactionList.filter((item) => item.description === "RECEIVABLE").map((el) => ({ label: el.paymentMethodName, value: el.paymentMethodName }));
      const checkedItems = salesList.filter((item) => item.isChecked);
      setDataPrintReceivableList(optApplication);
      setDataPrintList(checkedItems);
      setModalPrint(true);
    }
  }, [modalPrint, salesList, transactionList]);

  const toggleAccPayment = useCallback(() => {
    if (modalAccPayment) {
      setModalAccPayment(false);
    } else {
      setModalAccPayment(true);
    }
  }, [modalAccPayment]);

  const toggleReceipt = useCallback(() => {
    if (modalReceipt) {
      setModalReceipt(false);
    } else {
      setModalReceipt(true);
    }
  }, [modalReceipt]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggleMediaCustomer = useCallback(() => {
    if (modalMediaCustomer) {
      setModalMediaCustomer(false);
    } else {
      setModalMediaCustomer(true);
    }
  }, [modalMediaCustomer]);

  const toggleApprove = useCallback(() => {
    if (modalApprove) {
      setModalApprove(false);
    } else {
      setModalApprove(true);
    }
  }, [modalApprove]);

  const toggleDetail = useCallback(
    (type = null) => {
      if (modalDetail) {
        setModalDetail(false);
        setSales(null);
        setActionType(null);
      } else {
        setModalDetail(true);
      }
    },
    [modalDetail],
  );

  const handleClickTransDoc = (salesId, actionType = null) => {
    setActionType(actionType);
    dispatch(getAccTrans({ salesId: salesId, date: "all" }));
  };

  useEffect(() => {
    if (info && actionType !== null) {
      const dataInfoWithTrans = {
        ...info,
        sales_trans: accTranss,
      };

      setInfo(dataInfoWithTrans);

      switch (actionType) {
        case "detail":
          handleSalesClick(dataInfoWithTrans, actionType);
          break;
        default:
          break;
      }
      handleSalesClick(dataInfoWithTrans, actionType);
    }
  }, [accTranss]);

  const handleSalesClick = useCallback(
    (arg, type) => {
      setSalesData(arg);

      switch (type) {
        case "detail":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;

        case "edit":
          setIsPayment(false);
          setIsEdit(true);
          toggle();
          break;

        case "payment":
          setIsPayment(true);
          setIsEdit(true);
          toggle();
          break;

        default:
          toggle();
          break;
      }
    },
    [toggle, userType],
  );

  function setSalesData(data) {
    let salesDetail = [];
    if (data.sales_detail) {
      data.sales_detail.forEach((element) => {
        salesDetail.push({
          detailId: element.id,
          itemId: element.productVarianId,
          item: {
            label: `${element.name} - ${element.barcode}`,
            value: element.productVarianId,
            name: element.name,
            sku: element.sku,
            barcode: element.barcode,
            amount: Math.round(element.amount, 0),
            brandId: element.brandId,
            productId: element.productId,
            land_excess: element.land_excess,
            land_price: element.land_price,
            price_handling: element.price_handling,
          },
          amount: Math.round(element.amount, 0),
          quantity: Math.round(element.quantity, 0),
          total: Math.round(element.amount_total, 0),
          name: element.name,
          sku: element.sku,
          barcode: element.barcode,
          brandId: element.brandId,
          land_excess: element.land_excess,
          land_price: element.land_price,
          price_handling: element.price_handling,
          price_dp: element.price_dp,
          credit_amount: element.credit_amount,
          credit_decreased: element.credit_decreased,
          status: { label: element.statusId === 1 ? "Draft" : "Approved", value: element.statusId },
          statusId: element.statusId,
        });
      });
    }
    let files = [];
    if (data.sales_file && data.sales_file.length > 0) {
      data.sales_file.forEach((element) => {
        files.push({
          filename: element.filename,
          originalname: element.originalname,
        });
      });
    }

    setSalesImg(files);
    setSales({
      id: data.id,
      companyId: data.companyId,
      typeId: data.typeId,
      clientId: data.clientId,
      description: data.description,
      sales_customer: data.sales_customer,
      transactionat: data.transactionat,
      code: data.code === null ? "-" : data.code,
      company: data.sales_company && data.sales_company.name && { label: data.sales_company.name, value: data.sales_company.id },
      agent:
        data.sales_agent === null
          ? ""
          : {
            label: data.sales_agent.name,
            value: data.sales_agent.id,
          },
      branch:
        data.sales_branch == null
          ? ""
          : {
            label: data.sales_branch.name,
            value: data.sales_branch.id,
            sbum: parseFloat(data.sales_branch.sbum),
          },
      client:
        data.sales_client === null
          ? ""
          : {
            label: data.sales_client.name,
            value: data.sales_client.id,
          },
      sales_type:
        data.sales_type === null
          ? ""
          : {
            label: data.sales_type.name,
            value: data.sales_type.id,
          },
      sls_bb:
        data.sls_bb === null
          ? ""
          : {
            label: data.sls_bb.name,
            value: data.sls_bb.id,
          },
      customer:
        data.sales_customer === null
          ? ""
          : {
            label: data.sales_customer.name,
            value: data.sales_customer.id,
          },
      sales_channel: data.sales_channel && { label: data.sales_channel.name, value: data.sales_channel.id },
      status: data.sales_status && { label: data.sales_status.name, value: data.sales_status.id },
      status_deal: data.sales_deal_status && { label: data.sales_deal_status.name, value: data.sales_deal_status.id },
      status_bank: data.sales_bank_status && { label: data.sales_bank_status.name, value: data.sales_bank_status.id },
      taxAmount: data.tax_amount === null ? 0 : data.tax_amount,
      totalAmount: data.total_amount === null ? 0 : data.total_amount,
      tax_amount: data.tax_amount === null ? 0 : parseFloat(data.tax_amount),
      total_amount: data.total_amount === null ? 0 : parseFloat(data.total_amount),
      sub_amount: data.sub_amount === null ? 0 : parseFloat(data.sub_amount),
      book_amount: data.book_amount === null ? 0 : parseFloat(data.book_amount),
      handling_amount: data.handling_amount === null ? 0 : parseFloat(data.handling_amount),
      shipment_amount: data.shipment_amount === null ? 0 : parseFloat(data.shipment_amount),
      credit_amount: data.credit_amount === null ? 0 : parseFloat(data.credit_amount),

      cert_amount: data.cert_amount === null ? 0 : parseFloat(data.cert_amount),
      imb_amount: data.imb_amount === null ? 0 : parseFloat(data.imb_amount),
      electricity_amount: data.electricity_amount === null ? 0 : parseFloat(data.electricity_amount),
      jkk_amount: data.jkk_amount === null ? 0 : parseFloat(data.jkk_amount),
      bestek_amount: data.bestek_amount === null ? 0 : parseFloat(data.bestek_amount),
      water_amount: data.water_amount === null ? 0 : parseFloat(data.water_amount),
      sbum_amount: data.sbum_amount === null ? 0 : parseFloat(data.sbum_amount),
      ppjb_amount: data.ppjb_amount === null ? 0 : parseFloat(data.ppjb_amount),
      thp3_amount: data.thp3_amount === null ? 0 : parseFloat(data.thp3_amount),
      thp4_amount: data.thp4_amount === null ? 0 : parseFloat(data.thp4_amount),
      bn_amount: data.bn_amount === null ? 0 : parseFloat(data.bn_amount),
      pph_amount: data.pph_amount === null ? 0 : parseFloat(data.pph_amount),
      bphtb_amount: data.bphtb_amount === null ? 0 : parseFloat(data.bphtb_amount),
      materai_amount: data.materai_amount === null ? 0 : parseFloat(data.materai_amount),
      kyg_amount: data.kyg_amount === null ? 0 : parseFloat(data.kyg_amount),
      receivable: data.receivable === null ? 0 : parseFloat(data.receivable),

      statusId: data.statusId,
      statusDealId: data.statusDealId,
      tenor: data.tenor,
      bankat: data.bankat,
      completedat: data.completedat,
      approvedat: data.approvedat,
      description_bank: data.description_bank,
      sales_detail: data.sales_detail,
      item: salesDetail,
    });
  }

  const checkedAll = () => {
    const allChecked = salesList.every((item) => item.isChecked);
    const updatedData = salesList.map((item) => ({
      ...item,
      isChecked: !allChecked,
    }));

    setSalesList(updatedData);
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={salesList.every((item) => item.isChecked)} onChange={checkedAll} />,
        filterable: false,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return (
            <div className="hstack gap-2 pe-0 me-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = salesList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setSalesList(updatedData);
                }}
              />
              <ButtonGroup>
                <UncontrolledButtonDropdown>
                  <button
                    className={userRole && (userType === "admin" || userType === "client" || userType === "company" || userRole.split(",").indexOf("updateAccTransaction") !== -1) ? "btn btn-sm btn-soft-info" : "d-none"}
                    onClick={() => {
                      let itemName = data.sales_detail.length > 0 ? " " + data.sales_detail[0]?.name : "";
                      setItemName(itemName);
                      setReceiptName(data.sales_customer.name);
                      setBranchCode(data.sales_branch.branch_code);
                      setIsPayment(true);
                      setIsEdit(true);
                      //handleSalesClick(data, "payment");
                      setInfo(data);
                      handleClickTransDoc(data.id, "payment");
                    }}
                  >
                    <i className="ri-add-line label-icon align-middle rounded-pill me-0"></i> TRANSAKSI
                    {loadingAccTranss && info.id === data.id && actionType === "payment" && (
                      <Spinner size="sm" className="ms-2 flex-shrink-0" role="status">
                        Loading...
                      </Spinner>
                    )}
                  </button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "No Transaksi",
        accessor: "transaction_no",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          let stat;
          let statDeal;
          let statName = data.sales_status && data.sales_status.name;
          let statDealId = data.sales_deal_status && data.sales_deal_status.id;
          switch (statName) {
            case "DRAFT":
              stat = <span className="badge text-uppercase badge-soft-warning">{statName}</span>;
              break;
            case "PENDING":
              stat = <span className="badge text-uppercase badge-soft-secondary">{statName}</span>;
              break;
            case "CONFIRMED":
              stat = <span className="badge text-uppercase badge-soft-info">{statName}</span>;
              break;
            case "PROCESSED":
              stat = <span className="badge text-uppercase badge-soft-success">{statName}</span>;
              break;
            case "SHIPPED":
              stat = <span className="badge text-uppercase badge-soft-primary">{statName}</span>;
              break;
            case "COMPLETED":
              stat = <span className="badge text-uppercase badge-soft-success">{statName}</span>;
              break;
            default:
              stat = <span className="badge text-uppercase badge-soft-danger">{statName}</span>;
              break;
          }

          switch (statDealId) {
            case 3:
              statDeal =
                data.typeId === 3 || data.typeId === 4 ? (
                  <span className="badge text-uppercase" style={{ background: "#CFECF7", color: "#687FE5" }}>
                    {"CASH"}
                  </span>
                ) : (
                  <span className="badge text-uppercase" style={{ background: "#ffe7ff", color: "#ea33f7" }}>
                    {data.sales_deal_status.name}
                  </span>
                );
              break;
            case 4:
              statDeal = (
                <span className="badge text-uppercase" style={{ background: "#ede3c5", color: "#806b29" }}>
                  {data.sales_deal_status.name}
                </span>
              );
              break;
            case 5:
              statDeal = (
                <span className="badge text-uppercase" style={{ background: "#EAFAEA", color: "#65B741" }}>
                  {data.sales_deal_status.name}
                </span>
              );
              break;
            case 6:
              statDeal = (
                <span className="badge text-uppercase" style={{ background: "#FFFDF0", color: "#ffCC55" }}>
                  {data.sales_deal_status.name}
                </span>
              );
              break;
            case 7:
              statDeal = <span className="badge text-uppercase badge-soft-info">{data.sales_deal_status.name}</span>;
              break;
            case 8:
              statDeal = (
                <span className="badge text-uppercase" style={{ background: "#E8F9FF", color: "#2cc2c4" }}>
                  {data.sales_deal_status.name}
                </span>
              );
              break;
            default:
              statDeal = "";
              break;
          }

          return (
            <div
              className="cursor-pointer"
              onClick={() => {
                let itemName = data.sales_detail.length > 0 ? " " + data.sales_detail[0]?.name : "";
                setItemName(itemName);
                setReceiptName(data.sales_customer.name);
                setBranchCode(data.sales_branch.branch_code);
                setInfo(data);
                //handleSalesClick(data, "detail");
                handleClickTransDoc(data.id, "detail");
              }}
            >
              <div className="mb-1">
                <span className="fw-semibold">
                  {data.transaction_no}{" "}
                  {loadingAccTranss && info.id === data.id && actionType === "detail" && (
                    <Spinner size="sm" className="flex-shrink-0" role="status">
                      Loading...
                    </Spinner>
                  )}
                </span>
              </div>
              <div className="hstack gap-2">
                {stat}
                {statDeal}
              </div>
            </div>
          );
        },
      },
      {
        Header: "Konsumen",
        accessor: "sales_customer.name",
        filterable: true,
        Cell: (cell) => {
          let data = cell.row.original;
          let custName = data.sales_customer && data.sales_customer.name;
          let agentName = data.sales_agent && <span className="badge text-uppercase badge-soft-info">{data?.sales_agent?.name}</span>;
          let promo = data.sales_promo ? <span className="badge text-uppercase badge-soft-info">{data.sales_promo.name}</span> : "";
          let bank = data.sls_bb ? <span className="badge text-uppercase badge-soft-warning">{data.sls_bb.name}</span> : "";
          return (
            <div
              className="cursor-pointer"
              onClick={() => {
                let itemName = data.sales_detail.length > 0 ? " " + data.sales_detail[0]?.name : "";
                setItemName(itemName);
                setReceiptName(data.sales_customer.name);
                setBranchCode(data.sales_branch.branch_code);
                setInfo(data);
                // handleSalesClick(data, "detail");
                handleClickTransDoc(data.id, "detail");
              }}
            >
              <div className="mb-1 fw-semibold text-wrap" style={{ width: "250px" }}>
                {custName}
              </div>
              <div className="hstack gap-2">
                {agentName}
                {promo}
                {bank}
              </div>
            </div>
          );
        },
      },
      {
        id: "Bank",
        Header: "Bank",
        accessor: "sls_bb.name",
        filterable: true,
      },
      {
        id: "Blok",
        Header: "Blok",
        accessor: "blok",
        filterable: true,
      },
      {
        id: "Description",
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
        Cell: (cell) => {
          let data = cell.row.original;
          let blok = data.blok ? <span className="badge text-uppercase badge-soft-info">{data.blok}</span> : "";
          return (
            <div>
              <div className="mb-1 text-wrap" style={{ width: "150px" }}>{data.description}</div>
              <div className="hstack gap-2">{blok}</div>
            </div>
          );
        },
      },
      {
        id: "Tanggal",
        Header: "Tanggal",
        accessor: "completedat",
        filterable: false,
        Cell: (data) => {
          return data.row.original.completedat ? handleValidDate(data.row.original.completedat, "D/MM/YYYY") : "";
        },
      },
      {
        id: "Marketing",
        Header: "Marketing",
        accessor: "sales_agent.name",
        filterable: true,
      },
      {
        id: "tagihan",
        Header: <div style={{ minWidth: "110px" }}>Total Piutang</div>,
        accessor: (data) => parseFloat(data.receivable || 0) - (parseFloat(data.dp_amount || 0) + parseFloat(data.sbum_amount || 0) + parseFloat(data.cert_amount || 0) + parseFloat(data.imb_amount || 0) + parseFloat(data.electricity_amount || 0) + parseFloat(data.jkk_amount || 0) + parseFloat(data.bestek_amount || 0) + parseFloat(data.water_amount || 0) + parseFloat(data.ppjb_amount || 0) + parseFloat(data.thp3_amount || 0) + parseFloat(data.thp3_amount || 0)),
        filterable: true,
        Cell: (cell) => {
          return <div className={"fw-semibold text-primary"}>{currencyFormat(cell.value)}</div>;
        },
      },
      {
        Header: <div style={{ minWidth: "110px" }}>SBUM</div>,
        accessor: "sbum_amount",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          let tag = data.sbum_desc === "HOLD" ? <span className="badge text-uppercase badge-soft-danger">{data.sbum_desc}</span> : data.sbum_desc === "CAIR" ? <span className="badge text-uppercase badge-soft-success">{data.sbum_desc}</span> : data.sbum_desc === "POTENSI" ? <span className="badge text-uppercase badge-soft-warning">{data.sbum_desc}</span> : "";
          return (
            <div className=" ">
              {currencyFormat(data.sbum_amount || 0)} {tag}
            </div>
          );
        },
      },
      {
        Header: <div style={{ minWidth: "110px" }}>Sertifikat</div>,
        accessor: "cert_amount",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          let tag = data.cert_desc === "HOLD" ? <span className="badge text-uppercase badge-soft-danger">{data.cert_desc}</span> : data.cert_desc === "CAIR" ? <span className="badge text-uppercase badge-soft-success">{data.cert_desc}</span> : data.cert_desc === "POTENSI" ? <span className="badge text-uppercase badge-soft-warning">{data.cert_desc}</span> : "";
          return (
            <div className=" ">
              {currencyFormat(data.cert_amount || 0)} {tag}
            </div>
          );
        },
      },
      {
        Header: <div style={{ minWidth: "110px" }}>PBG</div>,
        accessor: "imb_amount",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          let tag = data.imb_desc === "HOLD" ? <span className="badge text-uppercase badge-soft-danger">{data.imb_desc}</span> : data.imb_desc === "CAIR" ? <span className="badge text-uppercase badge-soft-success">{data.imb_desc}</span> : data.imb_desc === "POTENSI" ? <span className="badge text-uppercase badge-soft-warning">{data.imb_desc}</span> : "";
          return (
            <div className=" ">
              {currencyFormat(data.imb_amount || 0)} {tag}
            </div>
          );
        },
      },
      {
        Header: <div style={{ minWidth: "110px" }}>Listrik</div>,
        accessor: "electricity_amount",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          let tag = data.electricity_desc === "HOLD" ? <span className="badge text-uppercase badge-soft-danger">{data.electricity_desc}</span> : data.electricity_desc === "CAIR" ? <span className="badge text-uppercase badge-soft-success">{data.electricity_desc}</span> : data.electricity_desc === "POTENSI" ? <span className="badge text-uppercase badge-soft-warning">{data.electricity_desc}</span> : "";
          return (
            <div className=" ">
              {currencyFormat(data.electricity_amount || 0)} {tag}
            </div>
          );
        },
      },
      {
        Header: <div style={{ minWidth: "110px" }}>JKK</div>,
        accessor: "jkk_amount",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          let tag = data.jkk_desc === "HOLD" ? <span className="badge text-uppercase badge-soft-danger">{data.jkk_desc}</span> : data.jkk_desc === "CAIR" ? <span className="badge text-uppercase badge-soft-success">{data.jkk_desc}</span> : data.jkk_desc === "POTENSI" ? <span className="badge text-uppercase badge-soft-warning">{data.jkk_desc}</span> : "";
          return (
            <div className=" ">
              {currencyFormat(data.jkk_amount || 0)} {tag}
            </div>
          );
        },
      },
      {
        Header: <div style={{ minWidth: "110px" }}>BESTEK</div>,
        accessor: "bestek_amount",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          let tag = data.bestek_desc === "HOLD" ? <span className="badge text-uppercase badge-soft-danger">{data.bestek_desc}</span> : data.bestek_desc === "CAIR" ? <span className="badge text-uppercase badge-soft-success">{data.bestek_desc}</span> : data.bestek_desc === "POTENSI" ? <span className="badge text-uppercase badge-soft-warning">{data.bestek_desc}</span> : "";
          return (
            <div className=" ">
              {currencyFormat(data.bestek_amount || 0)} {tag}
            </div>
          );
        },
      },
      {
        Header: <div style={{ minWidth: "110px" }}>Air</div>,
        accessor: "water_amount",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          let tag = data.water_desc === "HOLD" ? <span className="badge text-uppercase badge-soft-danger">{data.water_desc}</span> : data.water_desc === "CAIR" ? <span className="badge text-uppercase badge-soft-success">{data.water_desc}</span> : data.water_desc === "POTENSI" ? <span className="badge text-uppercase badge-soft-warning">{data.water_desc}</span> : "";
          return (
            <div className=" ">
              {currencyFormat(data.water_amount || 0)} {tag}
            </div>
          );
        },
      },
      {
        Header: <div style={{ minWidth: "110px" }}>PPJB</div>,
        accessor: "ppjb_amount",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          let tag = data.ppjb_desc === "HOLD" ? <span className="badge text-uppercase badge-soft-danger">{data.ppjb_desc}</span> : data.ppjb_desc === "CAIR" ? <span className="badge text-uppercase badge-soft-success">{data.ppjb_desc}</span> : data.ppjb_desc === "POTENSI" ? <span className="badge text-uppercase badge-soft-warning">{data.ppjb_desc}</span> : "";
          return (
            <div className=" ">
              {currencyFormat(data.ppjb_amount || 0)} {tag}
            </div>
          );
        },
      },
      {
        Header: <div style={{ minWidth: "110px" }}>Tahap 3</div>,
        accessor: "thp3_amount",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          let tag = data.thp3_desc === "HOLD" ? <span className="badge text-uppercase badge-soft-danger">{data.thp3_desc}</span> : data.thp3_desc === "CAIR" ? <span className="badge text-uppercase badge-soft-success">{data.thp3_desc}</span> : data.thp3_desc === "POTENSI" ? <span className="badge text-uppercase badge-soft-warning">{data.thp3_desc}</span> : "";
          return (
            <div className=" ">
              {currencyFormat(data.thp3_amount || 0)} {tag}
            </div>
          );
        },
      },
      {
        Header: <div style={{ minWidth: "110px" }}>Tahap 4</div>,
        accessor: "thp4_amount",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          let tag = data.thp4_desc === "HOLD" ? <span className="badge text-uppercase badge-soft-danger">{data.thp4_desc}</span> : data.thp4_desc === "CAIR" ? <span className="badge text-uppercase badge-soft-success">{data.thp4_desc}</span> : data.thp4_desc === "POTENSI" ? <span className="badge text-uppercase badge-soft-warning">{data.thp4_desc}</span> : "";
          return (
            <div className=" ">
              {currencyFormat(data.thp4_amount || 0)} {tag}
            </div>
          );
        },
      },
      {
        id: "Promo",
        Header: "Promo",
        accessor: "sales_promo.name",
        filterable: true,
      },
      {
        id: "Proyek",
        Header: "Project",
        accessor: "sales_branch.name",
        filterable: true,
      },
    ],
    [salesList, handleSalesClick, userRole, userType, accTranss, loadingAccTranss, actionType],
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: salesList,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Status", "Proyek", "Booking", "Promo", "Marketing", "Bank", "Blok"],
        pageIndex: indexPage,
        pageSize: 10,
        selectedRowIds: 0,
        sortBy: [
          {
            id: "Tanggal",
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
  );

  useEffect(() => {
    setIndexPage(pageIndex);
  }, [pageIndex]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    const param = {
      title: searchValue,
      type: searchType.value ?? "",
      startat: startat,
      endat: endat,
      branchId: branchSelected.value ?? "",
    };
    dispatch(onGetSales(param));
  }

  function handleResetFilter() {
    setFilterDate(null);
    setSearchType("");
    setSearchValue("");
    handleGetSales(branchSelected?.companyId, branchSelected?.value, true);
  }

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteSales(element.value));
    });
    checkall.checked = false;
  };

  const handleSelectFile = (file) => {
    setSalesImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMedia();
  };

  const handleSelectFileCustomer = (file) => {
    setSalesImgCustomer((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMediaCustomer();
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  function numberToWords(input) {
    const number = Number(input);

    if (isNaN(number)) {
      return "Input harus angka yang valid (contoh: 6500000 atau '6500000')";
    }

    if (number < 0) {
      return "Input harus non-negatif";
    }

    const num = Math.floor(number);

    if (num === 0) {
      return "Nol Rupiah";
    }

    const satuan = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan"];
    const belasan = ["Sepuluh", "Sebelas", "Dua Belas", "Tiga Belas", "Empat Belas", "Lima Belas", "Enam Belas", "Tujuh Belas", "Delapan Belas", "Sembilan Belas"];
    const puluhan = ["", "", "Dua Puluh", "Tiga Puluh", "Empat Puluh", "Lima Puluh", "Enam Puluh", "Tujuh Puluh", "Delapan Puluh", "Sembilan Puluh"];
    const skala = ["", "Ribu", "Juta", "Miliar", "Triliun", "Kuadriliun", "Kuintiliun"];

    function convertLessThanThousand(n) {
      if (n === 0) return "";
      if (n < 10) return satuan[n];
      if (n < 20) return belasan[n - 10];
      if (n < 100) {
        const p = puluhan[Math.floor(n / 10)];
        const s = satuan[n % 10];
        return p + (s ? " " + s : "");
      }
      const ratus = satuan[Math.floor(n / 100)];
      const sisa = n % 100;
      let hasil = ratus + " Ratus";
      if (sisa > 0) hasil += " " + convertLessThanThousand(sisa);
      return hasil;
    }

    let parts = [];
    let temp = num;
    while (temp > 0) {
      parts.push(temp % 1000);
      temp = Math.floor(temp / 1000);
    }

    let result = [];
    for (let i = parts.length - 1; i >= 0; i--) {
      const val = parts[i];
      if (val === 0) continue;

      let chunk = convertLessThanThousand(val);
      if (i > 0) {
        chunk += " " + skala[i];
      }
      if (chunk) result.push(chunk);
    }

    let final = result.join(" ");

    final = final.replace(/^Satu Ribu\b/, "Seribu");

    final = final.replace(/Satu Ratus(?=.*(Juta|Miliar|Triliun|Kuadriliun|Kuintiliun))/g, "Seratus");

    return final + " Rupiah";
  }

  const validationApprove = useFormik({
    enableReinitialize: true,
    initialValues: {
      approval_note: "",
    },
    onSubmit: (values) => {
      if (sales) {
        sales.setApprove = true;
        sales.approval_note = values.approval_note;
        dispatch(onUpdateSales(sales));
      }
      validationApprove.resetForm();
      toggleApprove();
    },
  });

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (sales && sales.id) || 0,
      statusId: (sales && sales.statusId) || 1,
      statusDealId: (sales && sales.statusDealId) || 3,
      sls_bb: (sales && sales.sls_bb) ?? "",
      sales_type: (sales && sales.sales_type) ?? "",
      sales_promo: (sales && sales.sales_promo) ?? "",
      company: (sales && sales.company) || companySelected,
      client: (sales && sales.client) || clientSelected,
      branch: (sales && sales.branch) || (branchSelected?.value === "all" ? "" : branchSelected),
      shipmentCarrier: (sales && sales.shipmentCarrier) || 0,
      shipmentMethod: (sales && sales.shipmentMethod) || 0,
      paymentMethod: (sales && sales.paymentMethod) ?? "",
      //paymentTerm: (sales && sales.paymentTerm) || 0,
      code: (sales && sales.code) ?? "",
      transactionat: (sales && sales.transactionat) ?? "",
      agent: (sales && sales.agent) ?? "",
      description: "",
      customer: (sales && sales.customer) ?? "",
      status: (sales && sales.status) ?? "",
      status_deal: (sales && sales.status_deal) ?? "",
      status_bank: (sales && sales.status_bank) ?? "",
      sales_channel: (sales && sales.sales_channel) ?? "",
      tax: (sales && sales.tax) || 0,
      tax_amount: (sales && sales.tax_amount) || 0,
      shipmentAmount: (sales && sales.shipmentAmount) || 0,
      total_amount: (sales && sales.total_amount) || 0,
      sub_amount: (sales && sales.sub_amount) || 0,
      book_amount: (sales && sales.book_amount) || 0,
      handling_amount: (sales && sales.handling_amount) || 0,
      shipment_amount: (sales && sales.shipment_amount) || 0,
      credit_amount: (sales && sales.credit_amount) || 0,
      tenor: (sales && sales.tenor) || 0,
      cash_amount: sales && sales.cash_amount ? sales.cash_amount : "",
      cashat: (sales && sales.cashat) ?? "",
      bankat: (sales && sales.bankat) ?? "",
      completedat: (sales && sales.completedat) ?? "",
      description_bank: (sales && sales.description_bank) ?? "",

      phone: "",
      name: "",
      proper: "",
      transaction_reff: "",
      blok: "",
      item: (sales && sales.item) || [],
    },
    validationSchema: Yup.object({
      branch: Yup.object().required("Silahkan pilih proyek").nullable(true),
      company: Yup.object().required("Silahkan pilih perusahaan").nullable(true),
      client: Yup.object().required("Silahkan pilih grup perusahaan").nullable(true),
      sls_bb: Yup.object().required("Silahkan pilih grup perusahaan").nullable(true),
      phone: Yup.string().required("Silahkan isi Tanggal Transaksi"),
      name: Yup.string().required("Silahkan isi Tanggal Transaksi"),
      proper: Yup.string().required("Silahkan isi Tanggal Transaksi"),
      transaction_reff: Yup.string().required("Silahkan isi Tanggal Transaksi"),
      blok: Yup.string().required("Silahkan isi Tanggal Transaksi"),
      completedat: Yup.string().required("Silahkan isi Tanggal Transaksi"),
    }),
    onSubmit: (values) => {
      let addSubmit = {
        transaction: "FINANCE",
        bankBranchId: values.sls_bb.value,
        clientId: values.client.value,
        companyId: values.company.value,
        branchId: values.branch.value,
        phone: values.phone,
        name: values.name,
        proper: values.proper,
        blok: values.blok,
        completedat: values.completedat,
        transaction_reff: values.transaction_reff,
      };
      dispatch(onAddNewSales(addSubmit));
      validation.resetForm();
      toggle();
    },
  });

  const validationAccPayment = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (sales && sales.id) || 0,
      amount: 0,
      name: (sales && sales?.sales_customer?.name) ?? "",
      transactionat: moment().format("YYYY/MM/DD"),
      paymentMethod: "",
      cashflow: "",
      description: "",
      accTransPaymentId: "",
    },
    validationSchema: Yup.object({
      amount: Yup.string().required("Please Pick Amount"),
      accTransPaymentId: Yup.string().required("Please Pick accTransPaymentId"),
      paymentMethod: Yup.object().required("Please Select Payment Method").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getSalesLoading());
      let data = {
        id: sales && sales.id,
        setAccPayment: true,
        setApprove: false,
        transactionat: values.transactionat,
        description: values.description,
        amount: values.amount,
        accTransPaymentId: values.accTransPaymentId,
        paymentMethodId: values.paymentMethod.value,
        budgetId: values.cashflow.value,
      };
      dispatch(onUpdateSales(data));
      validationAccPayment.resetForm();
      toggleAccPayment();
      toggle();
    },
  });

  useEffect(() => {
    const hasChecked = salesList.some((item) => item.isChecked);
    setIsButtonPrint(hasChecked);
  }, [salesList]);

  function handleTransactionSubmit() {
    for (const ft of transactionList) {
      if (sales && sales.id) {
        let editSubmit = {
          id: sales.id,
          transaction: "FINANCE",
          transaction_type: ft.sales,
          transactionat: ft.cashat,
          amount: ft.cash_amount,
          paymentMethodId: ft.paymentMethodId,
        };
        dispatch(onUpdateSales(editSubmit));
      }
    }
  }

  const toggleProgress = (type) => {
    let filteredAccTranss = saless;
    setActiveProgress(type);
    if (type !== "all") {
      if (type === "other") {
        let transList = [];
        for (const sales of saless) for (const trans of sales?.sales_trans || []) if (trans.at_payment && trans.at_payment.at_pm && (trans.at_payment.at_pm.sales === "thp3_amount" || trans.at_payment.at_pm.sales === "thp4_amount")) transList.push(sales);
        filteredAccTranss = transList;
      } else {
        let transList = [];
        for (const sales of saless) for (const trans of sales?.sales_trans || []) if (trans.at_payment && trans.at_payment.at_pm && trans.at_payment.at_pm.sales === type) transList.push(sales);
        filteredAccTranss = transList;
      }
    }
    setSalesList(filteredAccTranss);
  };

  const toggleCount = (type) => {
    let filteredAccTranss = [];
    if (type === "other") {
      let transList = [];
      for (const sales of saless) for (const trans of sales?.sales_trans || []) if (trans.at_payment && trans.at_payment.at_pm && (trans.at_payment.at_pm.sales === "thp3_amount" || trans.at_payment.at_pm.sales === "thp4_amount")) transList.push(sales);
      filteredAccTranss = transList;
    } else {
      let transList = [];
      for (const sales of saless) for (const trans of sales?.sales_trans || []) if (trans.at_payment && trans.at_payment.at_pm && trans.at_payment.at_pm.sales === type) transList.push(sales);
      filteredAccTranss = transList;
    }
    return filteredAccTranss.length;
  };

  document.title = "Pencairan KPR (MPD) | PESONA KAHURIPAN";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={salesList} />
      <DeleteModal show={deleteModal} title={info ? info.actionTitle : null} onDeleteClick={handleDeleteSales} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Keuangan" pageTitle="Piutang Dan Memo Pencairan Dana KPR" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createSales") !== -1 ? "btn btn-primary add-btn me-2" : "d-none"}
              id="create-btn"
              onClick={() => {
                setSales(null);
                setInfo(null);
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-add-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={salesDoc} />
          </div>
        </BreadCrumb>
        <Row>

          <Col xxl={12}>
            <Card>
              <CardBody className="pt-1">
                <div>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <Row>
                        <Col sm={1}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={3}>
                          <div className="me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              placeholder={`${countSearch} Search...`}
                              value={searchValue ?? ""}
                            />
                          </div>
                        </Col>
                        <Col sm={3}>
                          <Select
                            name="searchType"
                            value={searchType}
                            placeholder="Filter Jenis Penjualan"
                            onChange={(e) => {
                              setSearchType(e);
                              toggleType(e.value);
                            }}
                            options={salesTypeList}
                          ></Select>
                        </Col>
                        <Col sm={3}>
                          <div className="me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              value={filterDate}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}
                            />
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100 fw-semibold"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  <div
                    className="table-responsive table-card table-container-sticky mb-1 table-scroll"
                    ref={scrollRef}
                    onMouseDown={handleMouseDown}
                    onMouseLeave={handleMouseLeave}
                    onMouseUp={handleMouseUp}
                    onMouseMove={handleMouseMove}
                    // style={{ cursor: isDown ? "grabbing" : "grab", userSelect: isDown ? "none" : "auto" }}
                    style={{
                      overflow: "auto",
                      maxHeight: "calc(100vh - 340px)",
                      cursor: isDown ? "grabbing" : "grab",
                      //userSelect: isDown ? "none" : "auto",
                    }}
                  >
                    <Table hover {...getTableProps()} className="align-middle table-fixed-header table-nowrap">
                      <thead>
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        <tr className="bg-light">
                          <th colSpan={5} style={{ paddingLeft: "45px" }}>
                            {isButtonPrint && (
                              <>
                                <button type="button" className="btn btn-sm btn-info me-2" id="print-btn" onClick={togglePrint}>
                                  <i className="ri-printer-line me-1 fs-12"></i> PRINT DAJAM
                                </button>
                                <ButtonPrintInvoice innerRef={printRefInvoice} title={`print`} type="button" />
                              </>
                            )}
                            TOTAL PIUTANG
                          </th>
                          <th className="text-primary">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.tagihan || 0)), 0))}</th>
                          <th className="text-info">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.sbum_amount || 0)), 0))}</th>
                          <th className="text-info">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.cert_amount || 0)), 0))}</th>
                          <th className="text-info">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.imb_amount || 0)), 0))}</th>
                          <th className="text-info">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.electricity_amount || 0)), 0))}</th>
                          <th className="text-info">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.jkk_amount || 0)), 0))}</th>
                          <th className="text-info">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.bestek_amount || 0)), 0))}</th>
                          <th className="text-info">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.water_amount || 0)), 0))}</th>
                          <th className="text-info">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.ppjb_amount || 0)), 0))}</th>
                          <th className="text-info">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.thp3_amount || 0)), 0))}</th>
                          <th className="text-info">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.thp4_amount || 0)), 0))}</th>
                        </tr>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} value={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>

                <Modal id="showModal" isOpen={modal} centered size={!!isEdit ? "xl" : "lg"}>
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Transaksi Pencairan Dana Tunai" : "Tambah Debitur"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    {!!isEdit ? (
                      <ModalBody>
                        <CardBody className={"border-bottom ps-2 pe-2 position-relative"}>
                          <Row>
                            <Col lg={5} className="ms-auto">
                              <div className="row">
                                <div className="mb-1 fs-16 fw-semibold">{validation.values.company && validation.values.company.label}</div>
                                <div className="mb-1 fs-14">{validation.values.branch && validation.values.branch.label}</div>
                                <div className="mb-3 fs-14">{validation.values.sales_type && validation.values.sales_type.label}</div>
                              </div>
                            </Col>
                            <Col lg={3}></Col>
                            <Col lg={4} className="ms-auto">
                              <div className="mb-2 fs-14 fw-semibold">No Penjualan : {validation.values.code && validation.values.code}</div>
                              <div className="mb-2 fs-14 fw-semibold">
                                {validation.values.customer && validation.values.customer.label} <span className="badge text-uppercase badge-soft-info fs-12">{validation.values.agent && validation.values.agent.label}</span>
                              </div>
                              <div className="mb-2 fs-14 fw-semibold">ACC KPR : {currencyFormat(info.credit_amount)}</div>
                            </Col>
                          </Row>
                        </CardBody>
                        <CardBody className={"pt-0 pb-0 ps-2 pe-2"}>
                          <div className="pt-4">
                            <div className="row">
                              <div className="mb-2 col-lg-5">
                                {transactionList.map((obj, idx) => {
                                  return (
                                    <div className="row mb-1" key={idx}>
                                      <div className="mb-2 pt-2 col-lg-5 align-middle">{obj.paymentMethodName}</div>
                                      <div className="mb-2 col-lg-3">
                                        <Flatpickr
                                          className="form-control"
                                          id="datepicker-publish-input"
                                          value={obj.cashat ?? ""}
                                          placeholder="Tanggal"
                                          options={{
                                            mode: "single",
                                            dateFormat: "Y/m/d",
                                          }}
                                          onChange={(selectedDates, dateStr) => {
                                            let arr = [];
                                            for (const f of transactionList) {
                                              if (f.paymentMethodId === obj.paymentMethodId) f.cashat = dateStr;
                                              arr.push(f);
                                            }
                                            setTransactionList(arr);
                                          }}
                                        />
                                      </div>
                                      <div className="mb-2 col-lg-4">
                                        <CurrencyInput
                                          id="cash_amount"
                                          name="cash_amount"
                                          prefix="Rp. "
                                          style={{ border: "1px solid #ccc", width: "100%" }}
                                          className="form-control fw-semibold"
                                          placeholder="Jumlah Transaksi"
                                          value={obj.cash_amount}
                                          decimalsLimit={2}
                                          onFocus={(e) => e.target.select()}
                                          onValueChange={(value, name, values) => {
                                            let arr = [];
                                            for (const f of transactionList) {
                                              if (f.paymentMethodId === obj.paymentMethodId) f.cash_amount = parseFloat(value);
                                              arr.push(f);
                                            }
                                            setTransactionList(arr);
                                          }}
                                        />
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                              <div className="mb-2 col-lg-7">
                                <div className="table-responsive m-0 table-card">
                                  <Table className="mb-0">
                                    <thead className="align-middle">
                                      <tr className="table-active">
                                        <th scope="col" style={{ width: "20px" }}>
                                          #
                                        </th>
                                        <th scope="col">Transaksi</th>
                                        <th scope="col" className="text-center" style={{ width: "120px" }}>
                                          Jumlah
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {(info?.sales_trans || [])
                                        .sort((a, b) => a.transaction_no - b.transaction_no)
                                        .map((o, i) => {
                                          let type;
                                          switch (o?.type) {
                                            case "CASH IN":
                                              type = <span className="badge text-uppercase badge-soft-success">{o?.type}</span>;
                                              break;
                                            case "RECEIVABLE":
                                              type = <span className="badge text-uppercase badge-soft-info">{o?.type}</span>;
                                              break;
                                            case "CASH OUT":
                                              type = <span className="badge text-uppercase badge-soft-warning">{o?.type}</span>;
                                              break;
                                            case "PAYABLE":
                                              type = <span className="badge text-uppercase badge-soft-danger">{o?.type}</span>;
                                              break;
                                            default:
                                              type = <span className="badge text-uppercase badge-soft-primary">{o?.type}</span>;
                                              break;
                                          }
                                          return (
                                            <tr key={i}>
                                              <td className="product-id">{i + 1}</td>
                                              <td className="">
                                                <p className="m-0 mb-1">
                                                  <span className="fw-semibold me-2">{o.transaction_no}</span> {type} <em className="text-muted">{handleValidDate(o.transactionat, "D MMM YYYY")}</em>
                                                </p>
                                                <p className="m-0 mb-1">
                                                  {o.description} {o.type === "RECEIVABLE" && o.paid_amount > 0 && <span className="badge text-uppercase badge-soft-success">Cair {currencyFormat(o.paid_amount)}</span>}
                                                </p>
                                                <button
                                                  className={o.type === "RECEIVABLE" && o.amount - o.paid_amount > 0 ? "btn btn-sm btn-soft-info mt-1" : "d-none"}
                                                  onClick={() => {
                                                    validationAccPayment.setFieldValue("description", `PEMBAYARAN ${paymentMethods && (paymentMethods || []).find((f) => f.id === o.paymentMethodId)?.name} (${info?.sales_customer?.name} #${info?.code})`);
                                                    validationAccPayment.setFieldValue("accTransPaymentId", o.id);
                                                    validationAccPayment.setFieldValue("amount", o.amount - o.paid_amount);
                                                    toggleAccPayment();
                                                  }}
                                                >
                                                  <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i> PENCAIRAN
                                                </button>
                                              </td>
                                              <td className="fw-semibold text-center" style={{ width: "120px", verticalAlign: "middle" }}>
                                                {currencyFormat(o.amount)}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      {(info?.sales_trans || []).length === 0 && (
                                        <tr>
                                          <td colSpan="5" className="p-3 text-center fs-14">
                                            Belum ada transaksi
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </Table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </CardBody>
                      </ModalBody>
                    ) : (
                      <ModalBody>
                        <CardBody className={"pt-3 position-relative"}>
                          <Row className="border-bottom pb-3">
                            <Col lg={6} className="ms-auto">
                              <div className="row">
                                <div className="mb-3 d-none">
                                  <div className="position-relative">
                                    <Select
                                      name="client"
                                      value={validation.values.client}
                                      isDisabled={userType === "admin" || userType === "client" ? false : true}
                                      placeholder="Pilih Grup Usaha"
                                      onChange={(e) => {
                                        dispatch(setClientSelect(e));
                                        validation.setFieldValue("client", e);
                                      }}
                                      options={clientList}
                                    ></Select>
                                    <div className="position-absolute" style={{ top: "12px", left: "-24px" }}>
                                      {clientLoading && (
                                        <Spinner color="primary" size="sm">
                                          Loading...
                                        </Spinner>
                                      )}
                                    </div>
                                  </div>
                                  {validation.touched.client && validation.errors.client && (
                                    <p className="invalid-feedback d-block" type="invalid">
                                      {validation.errors.client}
                                    </p>
                                  )}
                                </div>
                                <div className="mb-3 d-none">
                                  <div className="position-relative">
                                    <Select
                                      name="company"
                                      value={validation.values.company}
                                      placeholder="Pilih Perusahaan"
                                      isDisabled={userType === "admin" || userType === "client" ? false : true}
                                      onChange={(e) => {
                                        dispatch(setCompanySelect(e));
                                        setBranchList([]);
                                        validation.resetForm({});
                                      }}
                                      options={companyList}
                                    ></Select>
                                    <div className="position-absolute" style={{ top: "12px", left: "-24px" }}>
                                      {companyLoading && (
                                        <Spinner color="primary" size="sm">
                                          Loading...
                                        </Spinner>
                                      )}
                                    </div>
                                  </div>
                                  {validation.touched.company && validation.errors.company && (
                                    <p className="invalid-feedback d-block" type="invalid">
                                      {validation.errors.company}
                                    </p>
                                  )}
                                </div>
                                <div className="mb-3">
                                  <Label htmlFor="name-field" className="form-label">
                                    Cabang / Proyek
                                  </Label>
                                  <Select
                                    name="branch"
                                    placeholder="Pilih Proyek"
                                    value={validation.values.branch}
                                    onChange={(e) => {
                                      validation.setFieldValue("branch", e);
                                    }}
                                    options={branchList}
                                  ></Select>
                                  {validation.touched.branch && validation.errors.branch && (
                                    <small className="text-danger" type="invalid">
                                      {validation.errors.branch}
                                    </small>
                                  )}
                                </div>
                                <div className="mb-3">
                                  <Label htmlFor="name-field" className="form-label">
                                    Bank Pengajuan
                                  </Label>
                                  <Select
                                    name="sls_bb"
                                    value={validation.values.sls_bb}
                                    placeholder="Pilih Bank Pengajuan"
                                    onChange={(e) => {
                                      validation.setFieldValue("sls_bb", e);
                                    }}
                                    options={bankBranchList}
                                  ></Select>
                                  {validation.touched.sls_bb && validation.errors.sls_bb && (
                                    <small className="text-danger" type="invalid">
                                      {validation.errors.sls_bb}
                                    </small>
                                  )}
                                </div>
                                <div className="mb-3">
                                  <Label htmlFor="name-field" className="form-label">
                                    Nama Konsumen
                                  </Label>
                                  <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama Konsumen" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                                  {validation.touched.name && validation.errors.name && <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>}
                                </div>
                                <div className="mb-3">
                                  <Label htmlFor="phone-field" className="form-label">
                                    No Telpon
                                  </Label>
                                  <Input name="phone" id="phone-field" className="form-control" placeholder="Isi No Telpon" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.phone ?? ""} invalid={validation.touched.phone && validation.errors.phone ? true : false} />
                                  {validation.touched.phone && validation.errors.phone && <FormFeedback type="invalid">{validation.errors.phone}</FormFeedback>}
                                </div>
                              </div>
                            </Col>
                            <Col lg={6} className="ms-auto">
                              <div className="row">
                                <div className="mb-3">
                                  <Label htmlFor="transaction_reff-field" className="form-label">
                                    No Debitur
                                  </Label>
                                  <Input name="transaction_reff" id="transaction_reff-field" className="form-control" placeholder="Isi No Debitur" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.transaction_reff ?? ""} invalid={validation.touched.transaction_reff && validation.errors.transaction_reff ? true : false} />
                                  {validation.touched.transaction_reff && validation.errors.transaction_reff && <FormFeedback type="invalid">{validation.errors.transaction_reff}</FormFeedback>}
                                </div>
                                <div className="mb-3">
                                  <Label htmlFor="blok-field" className="form-label">
                                    Blok
                                  </Label>
                                  <Input name="blok" id="blok-field" className="form-control" placeholder="Isi Blok" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.blok ?? ""} invalid={validation.touched.blok && validation.errors.blok ? true : false} />
                                  {validation.touched.blok && validation.errors.blok && <FormFeedback type="invalid">{validation.errors.blok}</FormFeedback>}
                                </div>
                                <div className="mb-3">
                                  <Label htmlFor="proper-field" className="form-label">
                                    Proper
                                  </Label>
                                  <Input name="proper" id="proper-field" className="form-control" placeholder="Isi Proper" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.proper ?? ""} invalid={validation.touched.proper && validation.errors.proper ? true : false} />
                                  {validation.touched.proper && validation.errors.proper && <FormFeedback type="invalid">{validation.errors.proper}</FormFeedback>}
                                </div>
                                <div className="mb-3">
                                  <Label htmlFor="proper-field" className="form-label">
                                    Tanggal Akad
                                  </Label>
                                  <Flatpickr
                                    className="form-control"
                                    id="datepicker-publish-input"
                                    placeholder="Tanggal"
                                    options={{
                                      mode: "single",
                                      dateFormat: "Y/m/d",
                                    }}
                                    onChange={(selectedDates, dateStr) => {
                                      validation.setFieldValue("completedat", dateStr);
                                    }}
                                    value={validation.values.completedat ?? ""}
                                  />
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                      </ModalBody>
                    )}
                    <div className="modal-footer">
                      <div className="d-flex justify-content-between w-100">
                        <div className="hstack gap-2 justify-content-end">
                          {!!isEdit ? (
                            <button className="btn btn-success" onClick={handleTransactionSubmit} disabled={loading}>
                              <span className="d-flex align-items-center">
                                {"SIMPAN TRANSAKSI KEUANGAN"}
                                &nbsp;{" "}
                                {loading && (
                                  <Spinner size="sm" className="flex-shrink-0" role="status">
                                    Loading...
                                  </Spinner>
                                )}
                              </span>
                            </button>
                          ) : (
                            <button type="submit" className="btn btn-success">
                              <span className="d-flex align-items-center">
                                <span className="flex-grow-1 me-2">SIMPAN PENJUALAN</span>
                                {loading && (
                                  <Spinner size="sm" className="flex-shrink-0" role="status">
                                    Loading...
                                  </Spinner>
                                )}
                              </span>
                            </button>
                          )}
                        </div>
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={() => {
                              toggle();
                              validation.resetForm({});
                            }}
                          >
                            TUTUP
                          </button>
                        </div>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    {"Detail Pemesanan"}
                  </ModalHeader>
                  <ModalBody>
                    {info && (
                      <CardBody className="pt-4 ps-4 pe-4">
                        <Row className="mb-0">
                          <Col lg={5} className="ms-auto">
                            <div className="row">
                              <div className="mb-1 fs-14 fw-semibold">{info.sales_client && info.sales_client.name}</div>
                              <div className="mb-3 fs-14 fw-semibold">{info.sales_company && info.sales_company.name}</div>
                              <div className="mb-1 fs-14">{info.sales_branch && info.sales_branch.name}</div>
                              <div className="mb-3 fs-14">
                                PENJUALAN {info.sales_type && info.sales_type.name} {info.tenor ? ", Tenor " + info.tenor + " Bulan" : ""}
                              </div>
                            </div>
                          </Col>
                          <Col lg={3}></Col>
                          <Col lg={4} className="ms-auto">
                            <div className="mb-2 fs-14 fw-semibold">No Penjualan : {info.transaction_no && info.transaction_no}</div>
                            <div className="mb-2 fs-14 fw-semibold">Bank Pengajuan : {info.sls_bb && info.sls_bb.name}</div>
                            <div className="mb-2 fs-14 fw-semibold">
                              {info.sales_customer && info.sales_customer.name} <span className="badge text-uppercase badge-soft-info fs-12">{info.sales_agent && info.sales_agent.name}</span>
                            </div>
                          </Col>
                        </Row>
                        <div>
                          <h4 className="mb-3 mt-3 pt-3 border-top">History Pembayaran</h4>
                          <div className="pt-3 ps-3 pe-3">
                            <div className="table-responsive mb-3 table-card">
                              <Table className="invoice-table table-borderless table-nowrap mb-0">
                                <thead className="align-middle">
                                  <tr className="table-active">
                                    <td></td>
                                    <td style={{ width: "20px" }}>#</td>
                                    <td>No Transaksi</td>
                                    <td>Tanggal Transaksi</td>
                                    <td className="text-end" style={{ width: "120px" }}>
                                      Jumlah
                                    </td>
                                    <td>Keterangan</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(info?.sales_trans || [])
                                    .filter((f) => f.statusId === 1 || f.statusId === 2 || f.statusId === 3)
                                    .map((o, i) => {
                                      let type;
                                      switch (o?.type) {
                                        case "CASH IN":
                                          type = <span className="badge text-uppercase badge-soft-success">{o?.type}</span>;
                                          break;
                                        case "RECEIVABLE":
                                          type = <span className="badge text-uppercase badge-soft-info">{o?.type}</span>;
                                          break;
                                        case "CASH OUT":
                                          type = <span className="badge text-uppercase badge-soft-warning">{o?.type}</span>;
                                          break;
                                        case "PAYABLE":
                                          type = <span className="badge text-uppercase badge-soft-danger">{o?.type}</span>;
                                          break;
                                        default:
                                          type = <span className="badge text-uppercase badge-soft-primary">{o?.type}</span>;
                                          break;
                                      }
                                      return (
                                        <tr key={i}>
                                          <td>
                                            <button
                                              className={o.type === "RECEIVABLE" && o.amount - o.paid_amount > 0 ? "btn btn-sm me-2 btn-soft-info" : "d-none"}
                                              onClick={() => {
                                                validationAccPayment.setFieldValue("description", `PEMBAYARAN ${paymentMethods && (paymentMethods || []).find((f) => f.id === o.paymentMethodId)?.name} (${info?.sales_customer?.name} #${info?.code})`);
                                                validationAccPayment.setFieldValue("accTransPaymentId", o.id);
                                                validationAccPayment.setFieldValue("amount", o.amount - o.paid_amount);
                                                toggleAccPayment();
                                              }}
                                            >
                                              <i className="ri-checkbox-circle-line label-icon align-middle me-1"></i> PENCAIRAN
                                            </button>
                                            <button
                                              type="button"
                                              className={o.type === "CASH IN" ? "btn btn-sm btn-soft-success" : "d-none"}
                                              onClick={() => {
                                                setReceiptAmount(o.amount);
                                                setReceiptDate(o.transactionat);
                                                setReceiptCode(o.transaction_no);
                                                setReceiptNote(o.description + itemName + ", " + branchCode);
                                                setModalDetail(false);
                                                toggleReceipt();
                                              }}
                                            >
                                              <i className="ri-printer-line label-icon align-middle me-1"></i>
                                              KWITANSI
                                            </button>
                                          </td>
                                          <td className="product-id">{i + 1}</td>
                                          <td>
                                            {o.transaction_no} {type}
                                          </td>
                                          <td>{handleValidDate(o.transactionat)}</td>
                                          <td className="text-end" style={{ width: "170px" }}>
                                            {currencyFormat(o.amount)}
                                          </td>
                                          <td>
                                            {o.description} {o.type === "RECEIVABLE" && o.paid_amount > 0 && <span className="badge text-uppercase badge-soft-success">Cair {currencyFormat(o.paid_amount)}</span>}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  {info.sales_trans && info.sales_trans.length === 0 && (
                                    <tr>
                                      <td colSpan="6" className="p-3 text-center fs-14">
                                        Belum ada transaksi Penerimaan
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          </div>
                          {info.credit_amount && info.credit_amount > 0 && (
                            <div className="row border-top">
                              <div className="col-lg-5 mt-3">
                                <div className="mb-3">
                                  <label className="text-muted">Maksimum KPR : </label>
                                  <div className="fw-semibold fs-16">{currencyFormat(parseFloat(info.sub_amount) - (parseFloat(info.sub_amount ?? 0) * (1 / 100) + parseFloat(info.typeId === 1 ? info.sales_branch?.sbum : 0)) || 0)}</div>
                                </div>
                                <div className="mb-3">
                                  <label className="text-muted">ACC KPR : </label>
                                  <div className={info.credit_amount ? "fw-semibold text-success fs-16" : "fw-semibold fs-16"}>{currencyFormat(info.credit_amount)}</div>
                                </div>
                                <div className="row">
                                  <div className="mb-1 col-lg-12">
                                    <label>Tanggal SP3K</label> {handleValidDate(info.bankat)} (Tenor {info.tenor})
                                  </div>
                                </div>
                                <div className="mb-1">
                                  <label>Status : </label> <span className="fw-semibold fs-14">{info.sales_bank_status && info.sales_bank_status.name}</span>
                                </div>
                                <div className="mb-3">
                                  <label>Keterangan Bank : </label> {info.description_bank ? info.description_bank : "-"}
                                </div>
                              </div>
                              <div className="col-lg-3"></div>
                              <div className="col-lg-4 mt-3">
                                <div className="mb-3">
                                  <label className="text-muted">Penurunan KPR : </label>
                                  <div className="fw-semibold fs-16 text-danger">{currencyFormat(parseFloat(info.sub_amount) - (parseFloat(info.sub_amount) * (1 / 100) + parseFloat(info.typeId === 1 ? info.sales_branch?.sbum : 0)) - info.credit_amount || 0)}</div>
                                </div>
                                <div className="mb-3">
                                  <label className="text-muted">TOTAL HARUS BAYAR : </label>
                                  <div className="fw-semibold text-danger fs-16">{currencyFormat(info.total_amount)}</div>
                                </div>
                              </div>
                            </div>
                          )}
                          {info.completedat && (
                            <div className="pt-4 border-top">
                              <h4 className="mb-3">Jadwal Akad</h4>
                              <div className="row">
                                <div className="mb-3 col-lg-4">
                                  <label>Tanggal Akad : </label> <span className="fw-semibold text-success fs-16">{info.completedat && handleValidDate(info.completedat)}</span>
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="pt-4 border-top">
                            <h4 className="mb-3">Dokumen Penjualan</h4>
                            <div className="mb-3">
                              {info.sales_file &&
                                info.sales_file.length > 0 &&
                                info.sales_file.map((f, i) => {
                                  if (f.isDeleted) {
                                    return null;
                                  } else {
                                    return (
                                      <div key={i} className="border-bottom mb-3">
                                        <div className="d-flex justify-content-between mb-3 align-items-center">
                                          <div className="me-2">
                                            {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                              <ModalImage showRotate={true} small={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt={info.name} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                            ) : (
                                              <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                                <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                              </Link>
                                            )}
                                          </div>
                                          <div className="text-truncate">{f.originalname}</div>
                                        </div>
                                      </div>
                                    );
                                  }
                                })}
                            </div>
                          </div>
                        </div>
                      </CardBody>
                    )}
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          setModalDetail(false);
                        }}
                      >
                        TUTUP
                      </button>
                    </div>
                  </div>
                </Modal>
                <Modal id="showModalReceipt" isOpen={modalReceipt} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleReceipt}>
                    KWITANSI PEMBAYARAN
                  </ModalHeader>
                  <ModalBody>
                    <Row>
                      <Col lg={12}>
                        <div className="hero-kwitansi" style={{ padding: "20px 20px 20px 20px" }}>
                          <div style={{ display: "inline-flex", padding: "5px 0", fontSize: "11px", marginBottom: "15px" }}>
                            <div style={{ paddingLeft: "10px", paddingRight: "40px", flex: "1", display: "flex", justifyContent: "center", flexDirection: "column", width: "120px" }}>
                              <img src={logoHas} alt="" height="80" width="80" />
                            </div>
                            <div style={{ textAlign: "left" }}>
                              <p style={{ fontWeight: "bold", fontSize: "12px", margin: 0 }}>PT HIKMAH ALAM SENTOSA</p>
                              <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Developer, Kontraktor & Trader</p>
                              <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Perum PESONA KAHURIPAN 1, Ruko Blok L No 1, Cikahuripan, Klapanunggal, Bogor</p>
                              <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Telp: 021-22886425 Email: pesonakahuripan@gmail.com</p>
                            </div>
                          </div>
                          <div style={{ borderTop: "1px solid #000000", borderBottom: "1px solid #000000", paddingTop: "30px", paddingBottom: "30px", display: "flex", justifyContent: "center", alignItems: "center", padding: "5px 0", marginBottom: "10px", fontSize: "22px", fontWeight: "bold" }}>KWITANSI</div>
                          <div>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "5px 0", marginBottom: "10px" }}>{`No : ${branchCode ?? ""}${receiptCode ?? "-"}`}</div>
                            <table style={{ marginTop: "10px", width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                              <tbody>
                                <tr>
                                  <td style={{ width: "200px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Telah Diterima Dari</td>
                                  <td style={{ width: "15px" }}>:</td>
                                  <td style={{ width: "100%" }}>{receiptName ?? "-"}</td>
                                </tr>
                                <tr>
                                  <td style={{ width: "200px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Banyaknya Uang</td>
                                  <td style={{ width: "15px" }}>:</td>
                                  <td style={{ width: "100%" }}>{`${receiptAmount !== null ? `${numberToWords(receiptAmount)}` : "-"}`}</td>
                                </tr>
                                <tr>
                                  <td style={{ width: "200px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Untuk Pembayaran</td>
                                  <td style={{ width: "15px" }}>:</td>
                                  <td style={{ width: "100%" }}>{receiptCode ? `Sales Invoice #${branchCode ?? ""}${receiptCode}` : "-"}</td>
                                </tr>
                                <tr>
                                  <td style={{ width: "200px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Keterangan</td>
                                  <td style={{ width: "15px" }}>:</td>
                                  <td style={{ width: "100%" }}>{receiptNote}</td>
                                </tr>
                              </tbody>
                            </table>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                              <div style={{ flex: "1 1 0%", marginTop: "40px" }}>
                                <div style={{ display: "flex", fontSize: "18px", fontWeight: "bold" }}>
                                  <div style={{ borderTop: "1px solid #000000", borderBottom: "1px solid #000000", padding: "10px 20px" }}>Jumlah</div>
                                  <div style={{ borderTop: "1px solid #000000", borderBottom: "1px solid #000000", padding: "10px 20px", backgroundColor: "rgb(255, 170, 0)" }}>{`Rp. ${currencyFormat(receiptAmount ?? 0)}`}</div>
                                </div>
                              </div>
                              <div style={{ textAlign: "center" }}>
                                <p style={{ marginTop: "30px", padding: "0", lineHeight: "0" }}>Bogor, {handleValidDate(receiptDate, "D MMM YYYY")}</p>
                                PT HIKMAH ALAM SENTOSA
                                <div style={{ textAlign: "center", padding: "10px 0px" }}>
                                  <QRCodeSVG value={`https://pkg.pkdeveloper.id/qr/sl${receiptCode}-${companySelected?.value}`} size={90} bgColor={"#ffffff"} fgColor={"#000000"} level={"L"} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          toggleReceipt();
                        }}
                      >
                        TUTUP
                      </button>
                    </div>
                  </div>
                </Modal>

                <Modal id="showModalAccPayment" isOpen={modalAccPayment} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleAccPayment}>
                    PENERIMAAN PIUTANG
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationAccPayment.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="paymentMethod-field" className="form-label">
                            Jenis Transaksi
                          </Label>
                          <Select
                            name="paymentMethod"
                            value={validationAccPayment.values.paymentMethod}
                            placeholder="Pilih Jenis Transaksi"
                            onChange={(e) => {
                              validationAccPayment.setFieldValue("paymentMethod", e);
                            }}
                            options={paymentMethodList}
                          ></Select>
                          {validationAccPayment.touched.paymentMethod && validationAccPayment.errors.paymentMethod && (
                            <small className="text-danger" type="invalid">
                              {validationAccPayment.errors.paymentMethod}
                            </small>
                          )}
                        </div>
                        <div className="mb-3 col-lg-3">
                          <Label htmlFor="amount-field" className="form-label">
                            Jumlah
                          </Label>
                          <CurrencyInput
                            id="amount"
                            name="amount"
                            prefix="Rp. "
                            style={{ border: "1px solid #ccc", width: "100%" }}
                            className="form-control fw-semibold"
                            placeholder="Jumlah Transaksi"
                            value={validationAccPayment.values.amount}
                            decimalsLimit={2}
                            onFocus={(e) => e.target.select()}
                            onValueChange={(value, name, values) => {
                              validationAccPayment.setFieldValue("amount", parseFloat(value));
                            }}
                          />
                          {validationAccPayment.touched.amount && validationAccPayment.errors.amount ? <FormFeedback type="invalid">{validationAccPayment.errors.amount}</FormFeedback> : null}
                        </div>
                        <div className="mb-3 col-lg-3">
                          <Label htmlFor="amount-field" className="form-label">
                            Tgl Pembayaran
                          </Label>
                          <Flatpickr
                            className="form-control"
                            id="datepicker-publish-input"
                            placeholder="Select transaction date"
                            options={{
                              mode: "single",
                              dateFormat: "Y/m/d",
                            }}
                            onChange={(selectedDates, dateStr) => {
                              validationAccPayment.setFieldValue("transactionat", dateStr);
                            }}
                            value={validationAccPayment.values.transactionat ?? ""}
                          />
                        </div>
                        <div className="mb-3 col-lg-4 d-none">
                          <Label className="form-label">Cashflow</Label>
                          <Select
                            name="cashflow"
                            value={validationAccPayment.values.cashflow}
                            placeholder="Pilih Cashflow"
                            onChange={(e) => {
                              validationAccPayment.setFieldValue("cashflow", e);
                            }}
                            options={budgetList}></Select>
                          {validationAccPayment.touched.cashflow && validationAccPayment.errors.cashflow && (
                            <small className="text-danger" type="invalid">
                              {validationAccPayment.errors.cashflow}
                            </small>
                          )}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="address-field" className="form-label">
                            Keterangan
                          </Label>
                          <Input type="textarea" className="form-control" id="description" placeholder="Isi Keterangan " name="description" rows={3} value={validationAccPayment.values.description ?? ""} onBlur={validationAccPayment.handleBlur} onChange={validationAccPayment.handleChange} invalid={validationAccPayment.touched.description && validationAccPayment.errors.description ? true : false} />
                          {validationAccPayment.touched.description && validationAccPayment.errors.description && (
                            <small className="text-danger" type="invalid">
                              {validationAccPayment.errors.description}
                            </small>
                          )}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalAccPayment(false);
                            validationAccPayment.resetForm();
                          }}>Close
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">SIMPAN PEMBAYARAN</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModalApprove" isOpen={modalApprove} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleApprove}>
                    KONFIRMASI DATA
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationApprove.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="text-center">
                        <lord-icon src="https://cdn.lordicon.com/puvaffet.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style={{ width: "100px", height: "100px" }}></lord-icon>
                        <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                          <p className="fs-16">{sales && sales.actionTitle}</p>
                        </div>
                        <div className="mt-3 col-lg-12">
                          <Input name="approval_note" id="approval_note-field" className="form-control" placeholder="Enter Notes If Any" rows={4} type="textarea" onChange={validationApprove.handleChange} onBlur={validationApprove.handleBlur} />
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalApprove(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">Submit</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                {/* //// print */}
                <Modal id="showModalPrintSetting" isOpen={modalPrint} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={togglePrint}>
                    Pengaturan Print
                  </ModalHeader>
                  <ModalBody>
                    <div className="row p3">
                      <div className="mb-3">
                        <Label htmlFor="proyek-print-field" className="form-label">
                          Proyek
                        </Label>
                        <Select
                          name="proyek-print"
                          value={dataPrintSelected.proyek}
                          placeholder="Pilih Proyek"
                          onChange={(e) => {
                            setDataPrintSelected((prevVal) => ({
                              ...prevVal,
                              proyek: e,
                            }));
                          }}
                          options={[...proyekPrintOptions, ...branchList.flatMap((el) => el.options)]}
                        ></Select>
                      </div>
                      <div className="mb-3">
                        <Label htmlFor="bank-print-field" className="form-label">
                          Bank
                        </Label>
                        <Select
                          name="bank-print"
                          value={dataPrintSelected.bank}
                          placeholder="Pilih Bank"
                          onChange={(e) => {
                            setDataPrintSelected((prevVal) => ({
                              ...prevVal,
                              bank: e,
                            }));
                          }}
                          options={bankPrintOptions}></Select>
                      </div>
                      <div className="mb-3">
                        <Label htmlFor="application-print-field" className="form-label">
                          Type Permohonan
                        </Label>
                        <Select
                          name="application-print"
                          value={dataPrintSelected.application}
                          placeholder="Pilih Permohonan"
                          onChange={(e) => {
                            setDataPrintSelected((prevVal) => ({
                              ...prevVal,
                              application: e,
                            }));
                          }}
                          options={dataPrintReceivableList}
                        ></Select>
                      </div>
                    </div>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button type="button" className="btn btn-light" onClick={togglePrint}>
                        Close
                      </button>
                      <ButtonPrint innerRef={printRef} title={`print`} />
                      {/* <button type="submit" className="btn btn-info" onClick={handleDownloadExcel}>
                        Excel
                      </button> */}
                    </div>
                  </div>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
                <ModalInputFile onSelect={handleSelectFileCustomer} loading={loading} modal={modalMediaCustomer} toggle={toggleMediaCustomer} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <PrintDoc innerRef={printRef} data={dataPrintList} dataSetting={dataPrintSelected} />
      <PrintInvoice innerRef={printRefInvoice} data={salesList.filter((item) => item.isChecked)} branchCode={branchSelected?.branch_code} companyName={companySelected?.label} companyValue={companySelected?.value} />
      {/* {dataPrintList.length > 0 && <PrintDoc innerRef={printRef} data={dataPrintList} />} */}
    </div>
  );
};
Sales.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(Sales));
